(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-sticky-add-to-cart"]) return;
  try {
    
    
  (function() {

    const updateSelectors = window.Shopify.OptionSelectors.prototype.updateSelectors
    const buildSelectors = window.Shopify.OptionSelectors.prototype.buildSelectors
      
    window.Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
  
      var o = this.selectedValues(),
        i = this.product.getVariant(o);

        setTimeout(() => {
          
          for (var m = 0; m < this.product.optionNames().length; m++) {

            var values = this.product.optionValues(m), 
              name = this.product.optionNames()[m];

            var image = document.querySelector('.product-image'),
              buttonText = document.querySelector('.purchase-details button .text'),
              button = document.querySelector('.product-button button'),
              ctaText = document.querySelector('.product-button button .text');
            
            image.innerHTML = `<img src="${ i.featured_image ? i.featured_image.src : this.product.featured_image }" />`;
            ctaText.innerHTML = buttonText.innerHTML;

            if ( name.toLowerCase().includes('color') ) {
      
              document.querySelectorAll(`.color-control input[type="radio"][name="color"]`).forEach(function( color ){
                color.checked = color.value === o[0] ? true : false;
              });

            } else if ( name.toLowerCase().includes('bundle') ) {

              document.querySelector(`.select-control`).value = o[0];

            } 

            if ( !i.available ) {
                button.classList.add('disabled');
                button.setAttribute('disabled', 'disabled');
              } else {
                button.classList.remove('disabled');
                button.removeAttribute('disabled');
              }

              button.addEventListener('click', function(){

                document.querySelector('.purchase-details .ajax-submit').click();

              });

          }

        });

      return updateSelectors.apply( this, arguments );
    
    }

    window.Shopify.OptionSelectors.prototype.buildSelectors = function() {

      var self = this;

      var sticky = document.querySelector('.mobile-sticky-add-to-cart'),
        label = document.querySelector('.option-label'),
        selector = document.querySelector('.option-selector');

      for (var t = 0; t < this.product.optionNames().length; t++) {

        var values = this.product.optionValues(t), 
          name = this.product.optionNames()[t], 
          element = document.createElement("select");
          
        if ( name.toLowerCase().includes('color') ) {

          sticky.classList.add('sticky-product-color');
          label.innerHTML = 'Select ' + name;

          for (var r = 0; r < values.length; r++) {

            element = document.createElement("div");

            var input = document.createElement("input"),
              label = document.createElement("label");

            input.value = values[r];
            input.setAttribute('type', 'radio');
            input.setAttribute('name', 'color');
            input.setAttribute('id', 'input-radio-' + r);

            input.onchange = function(e, i) {

              var value = this.value;

              window.Shopify.each(self.selectors, function(select) {

                var i = i || {};
                select.element.value = value;

                self.updateSelectors(e, i);

              });

            }

            label.className = 'tooltip-wrap';
            label.setAttribute('for', 'input-radio-' + r);
            label.setAttribute('data-color', values[r]);
            label.innerHTML = `
              ${ createColor(values[r]) }
              ${ createTooltip(values[r]) }
            `;
            
            element.className = 'color-control';
            element.appendChild(input);
            element.appendChild(label);

            selector.appendChild(element);

          }

        } else if ( name.toLowerCase().includes('bundle') ) {

          sticky.classList.add('sticky-product-bundle');
          label.innerHTML = name;

          for (var r = 0; r < values.length; r++) {

            var option = document.createElement("option");

            option.value = values[r];
            option.innerHTML = values[r];

            element.appendChild(option);

          }

          element.className = 'select-control';

          element.onchange = function(e, i) {

            var value = this.value;

            window.Shopify.each(self.selectors, function(select) {

              var i = i || {};
              select.element.value = value;

              self.updateSelectors(e, i);

            });

          }

          selector.appendChild(element);

        } else {

          sticky.classList.add('sticky-product-default');

        }
        
      }

      return buildSelectors.apply( this, arguments );

    }

    function createTooltip( value ) {

      return `
        <div class="tooltip">${ value }</div>
      `;

    }

    function createColor( value ) {

      var colors = ["aliceblue","antiquewhite","aqua","aquamarine","azure","beige","bisque","black","blanchedalmond","blue","blueviolet","brown","burlywood","cadetblue","chartreuse","chocolate","coral","cornflowerblue","cornsilk","crimson","cyan","darkblue","darkcyan","darkgoldenrod","darkgray","darkgreen","darkkhaki","darkmagenta","darkolivegreen","darkorange","darkorchid","darkred","darksalmon","darkseagreen","darkslateblue","darkslategray","darkturquoise","darkviolet","deeppink","deepskyblue","dimgray","dodgerblue","firebrick","floralwhite","forestgreen","fuchsia","gainsboro","ghostwhite","gold","goldenrod","gray","green","greenyellow","honeydew","hotpink","indianred","indigo","ivory","khaki","lavender","lavenderblush","lawngreen","lemonchiffon","lightblue","lightcoral","lightcyan","lightgoldenrodyellow","lightgreen","lightgrey","lightpink","lightsalmon","lightseagreen","lightskyblue","lightslategray","lightsteelblue","lightyellow","lime","limegreen","linen","magenta","maroon","mediumaquamarine","mediumblue","mediumorchid","mediumpurple","mediumseagreen","mediumslateblue","mediumspringgreen","mediumturquoise","mediumvioletred","midnightblue","mintcream","mistyrose","moccasin","navajowhite","navy","oldlace","olive","olivedrab","orange","orangered","orchid","palegoldenrod","palegreen","paleturquoise","palevioletred","papayawhip","peachpuff","peru","pink","plum","powderblue","purple","red","rosybrown","royalblue","saddlebrown","salmon","sandybrown","seagreen","seashell","sienna","silver","skyblue","slateblue","slategray","snow","springgreen","steelblue","tan","teal","thistle","tomato","turquoise","violet","wheat","white","whitesmoke","yellow","yellowgreen"];
        colorFound = false,
        color = value;

      value.trim().split(' ').forEach(function(item) {
        
        if ( colors.includes(item.toLowerCase().trim()) ) {
          colorFound = true;
          color = item;
        }
        
      });

      return `<div class="color" style="background-color: ${ color }; ${ color.toLowerCase() == 'white' ? 'border: 1px solid #808080;' : '' }"></div>`;

    }

    window.addEventListener('load', function() {
      window.addEventListener('scroll', function(){
        var body = document.querySelector('body');
        var section = document.querySelector('.purchase-details')
        var CTAposition = section.getBoundingClientRect();
        if( (CTAposition.top + CTAposition.height) < 0 ){
            body.classList.add('mobile-sticky');
        }else{
            body.classList.remove('mobile-sticky');
        }
      });
    });

  })();
    
  
  } catch(e) { console.error(e); }
})();
})();
